import { environment } from '../environments/environment';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { routes } from './app.routes';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MainModule } from './main/main.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { MaterialsModule } from './shared/modules/material.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastMessageComponent } from './shared/components/toast-message/toast-message.component';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';
import { MsalConfigDynamicModule } from './msal-config-dynamic.module';
import { AdminStationModule } from './admin-station/admin-station.module';
import { DrawerModule } from './shared/components/drawer/drawer.module';
import { ApplicationInsightsErrorHandler } from './insights/insights.errorhandler';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

import { MatBottomSheet, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ButtonsModule } from './shared/components/buttons/buttons.module';
import { DirectiveModule } from './shared/directives/directive.module';

export const httpLoaderFactory = (http: HttpClient) => new TranslateHttpLoader(http);

@NgModule({
  declarations: [AppComponent, HomeComponent, ToastMessageComponent, ConfirmDialogComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule,
    MaterialsModule,
    MainModule,
    AdminStationModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    SharedModule,
    ImageCropperModule,
    DirectiveModule,
    ButtonsModule,
    NgIdleKeepaliveModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    HttpClientModule,
    RouterModule.forRoot(routes, { useHash: true }),
    MsalConfigDynamicModule.forRoot(`../assets/config/${environment.production ? 'config.json' : 'config.dev.json'}`),
    DrawerModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: MatBottomSheet },
    { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} },
    { provide: ErrorHandler, useClass: ApplicationInsightsErrorHandler },
  ],
})
export class AppModule {}
